const FETCH_GALLERY = 'FETCH_GALLERY';
const FETCH_GALLERY_SUCCESS = 'FETCH_GALLERY_SUCCESS';
const FETCH_GALLERY_ERROR = 'FETCH_GALLERY_ERROR';

const defaultState = {
    images: [],
    loading: false,
    error: null
};

export default function galleryReducer(state = defaultState, action) {
    switch (action.type) {
        case FETCH_GALLERY:
            return {
                loading: true,
                error: null,
                images: []
            }
        case FETCH_GALLERY_SUCCESS:
            return {
                loading: false,
                error: null,
                images: action.payload
            }
        case FETCH_GALLERY_ERROR:
            return {
                loading: false,
                error: action.payload,
                images: []
            }
        default:
            return state
    }
}